import React, { useState, useContext } from 'react';
import styles from './ChatFooter.module.sass';
import 'react-sliding-side-panel/lib/index.css';
import emojis from "./emoji.json"
import { IconButton } from '@mui/material';
import InsertEmoticonIcon from "@mui/icons-material/InsertEmoticon";
import MicNoneIcon from "@mui/icons-material/MicNone";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import SendIcon from "@mui/icons-material/Send";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ChatContext } from "../../../contexts/ChatContext";
import CallIcon from '@mui/icons-material/Call';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import { useEffect } from 'react';
import { ConquerContext } from '../../../contexts/ConquerContext';
import GamesGrid from '../../../components/Games/GamesGrid';
import cn from 'classnames'
import { GameContext } from '../../../contexts/GamesContext';
import OutsideClickHandler from 'react-outside-click-handler';

const ChatFooter = ({}) => {

    const conquer = useContext( ConquerContext );
    const chatContext = useContext(ChatContext)
    const {show,hide} = useContext( GameContext );

    const [inputText, setInputText] = useState("");
    const [showEmojiBox, setShowEmojiBox] = useState(false);
    const [showGamesBox, setShowGamesBox] = useState(false);
    const [gamesData, setGamesData] = useState([]);
  
    useEffect( () => {

        const LoadGames = async function(){
            let games = await conquer.Games.get();
            setGamesData( games );
        };
        LoadGames();

    } );

    const handleKeyDown = (event) => {
        if (event.key === "Enter") doSendMessage();
    };
  
    const handleSendButton = () => {
      doSendMessage();
    }
  
    const onGameClick = ( gameData ) => {
        chatContext.sendMessage( "Let's play " + gameData.name, {gameKey: gameData.gameKey} );
        show( {gameKey: gameData.gameKey} );
        setShowGamesBox( false );
    }

    const doSendMessage = async () => {

        if (inputText !== '') chatContext.sendMessage( inputText );

        setInputText( '' );
        setShowEmojiBox(false);

    }
  
    const handleClickOneEmoji = (emoji) => {
      setInputText(inputText + emoji)
    };
  
    const handleEmojiButton = () => {
      setShowEmojiBox((prev) => {
        return !prev;
      });
    };

    const handleGamesButton = () => {
        setShowGamesBox((prev) => {return !prev;});
    };

    return (
        <>
            {showEmojiBox && (
                <OutsideClickHandler onOutsideClick={() => { setShowEmojiBox(false) }}>
                    <div className={cn(styles.emoji_container, styles.open_panel)}>
                        <div className={styles.grid_container}>
                            {emojis.map((emoji) => {
                                return (
                                    <div
                                        className={styles.grid_item}
                                        onClick={() => handleClickOneEmoji(emoji)}>
                                        {emoji}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </OutsideClickHandler>
            )}

            {showGamesBox && (
                <OutsideClickHandler onOutsideClick={() => { setShowGamesBox(false) }}>
                    <div className={cn( styles.games_container, styles.open_panel )}>
                        <div className={styles.grid_container}>
                            <GamesGrid className={styles.gamesGridChat} gamesData={gamesData} onGameClick={onGameClick}/>
                        </div>
                    </div>
                </OutsideClickHandler>
            )}

            <div className={styles.container}>

                <div className={styles.container__inputEmoji}>
                    <IconButton aria-label='emoj' onClick={handleEmojiButton}>
                        {showEmojiBox ? (
                            <ExpandMoreIcon
                                className={styles.container__inputRight__emoj}
                            />
                        ) : (
                            <InsertEmoticonIcon
                                className={styles.container__inputRight__emoj}
                            />
                        )}
                    </IconButton>
                </div>

                
                <div className={styles.container__inputLeft}>
                    <input
                        className={styles.input}
                        type='text'
                        name='message'
                        value={inputText}
                        placeholder='Start typing...'
                        onKeyDown={handleKeyDown}
                        onChange={(e) => setInputText(e.target.value)}
                    />
                </div>
                <div className={styles.container__inputRight}>

                    {/*
                    { chatContext.isPersistent && <IconButton className={styles.chatAction} aria-label='send' onClick={() => { chatContext.peer.startCall() }}>
                        <CallIcon
                            className={styles.container__inputRight__send}
                        />
                    </IconButton>}
                    */}

                    <IconButton aria-label='games' onClick={handleGamesButton} >
                        <SportsEsportsIcon
                            className={styles.container__inputRight__send}
                        />
                    </IconButton>

                    {/* <IconButton aria-label='mic'>
                        <MicNoneIcon
                            className={styles.container__inputRight__mic}
                        />
                    </IconButton> */}

                    {/* <IconButton
                        aria-label='attach'
                        style={{ marginRight: '20px' }}>
                        <AttachFileIcon
                            className={styles.container__inputRight__attach}
                        />
                    </IconButton> */}

                    <IconButton aria-label='send' onClick={handleSendButton}>
                        <SendIcon
                            className={styles.container__inputRight__send}
                        />
                    </IconButton>
                </div>
            </div>
        </>
    );
};

export default ChatFooter;
